(function (angular, $, window) {
    'use strict';

    window.THF.Angular.LiveQuoteTool.animation('.loading-animation', [function() {
        var height = 5;

        return {
            addClass: function(element, className, doneFn) {
                // do some cool animation and call the doneFn
                $('span', $(element)).css({display: 'block'});
                $(element).animate({height: '100%'}, 100);
            },
            removeClass: function(element, className, doneFn) {
                // do some cool animation and call the doneFn
                $(element).animate({height: height}, 100, function () {
                    $('span', $(element)).css({display: 'none'});
                });
            },
            setClass: function(element, addedClass, removedClass, doneFn) {
                // do some cool animation and call the doneFn
                console.log( 'animate set' );
            }
        }
    }]);


})(angular, jQuery, window);
